import { useTheme } from '@material-ui/core/styles';
import colors from 'constants/colors';
import React, { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import * as api from 'utils/apiCalls';
import PropTypes from 'prop-types';

InteractionsGraph.propTypes = {
  externalMeetingId: PropTypes.string.isRequired,
  instanceId: PropTypes.string.isRequired,
};

export default function InteractionsGraph(props) {
  const { externalMeetingId, instanceId } = props;
  const theme = useTheme();
  const [data, setData] = useState({
    labels: ['Hands Raised', 'Messages Sent'],
    datasets: [
      {
        data: [],
        backgroundColor: colors,
        hoverBackgroundColor: colors,
      },
    ],
  });

  const doughnutOptions = {
    legend: {
      display: true,
      position: 'right',
    },
    title: {
      display: true,
      position: 'top',
      fontSize: '24',
      fontColor: theme.palette.primary.main,
      text: 'Interactions',
    },
  };

  useEffect(() => {
    const updateGraph = async () => {
      if (externalMeetingId && instanceId) {
        const newMessages = await api.getAllMeetingMessages(externalMeetingId, instanceId);

        var res = newMessages.reduce((obj, v) => {
          obj[v.type] = (obj[v.type] || 0) + 1;
          return obj;
        }, {});

        setData({
          labels: ['Hands Raised', 'Messages Sent'],
          datasets: [
            {
              data: [res['raise-hand'], res['chat-message']],
              backgroundColor: colors,
              hoverBackgroundColor: colors,
            },
          ],
        });
      }
    };
    updateGraph();
  }, [externalMeetingId, instanceId]);

  return (
    <span data-testid="doughnut">
      <Doughnut data={data} options={doughnutOptions} />
    </span>
  );
}
